import React, { useState } from 'react';
import { MessageSquareIcon, PlusIcon, RulerIcon } from 'lucide-react';
export const NavigationControls = () => {
  const [isHovered, setIsHovered] = useState(false);
  return <div className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-70 backdrop-blur-sm rounded-lg shadow-lg px-1.5 py-2 transition-all duration-300" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} data-id="element-66">
      <div className="flex flex-col" data-id="element-67">
        <button className="flex items-center gap-2 px-2 py-1.5 hover:bg-gray-100 rounded-md transition-colors" title="Lisa kommentaar" data-id="element-68">
          <div className="relative flex-shrink-0 w-[20px] flex items-center justify-center" data-id="element-69">
            <MessageSquareIcon size={18} data-id="element-70" />
            <PlusIcon size={10} className="absolute -top-1 -right-1 bg-white rounded-full text-orange-500" data-id="element-71" />
          </div>
          <span className={`text-xs whitespace-nowrap overflow-hidden transition-all duration-300 ${isHovered ? 'opacity-100 max-w-[100px]' : 'opacity-0 max-w-0'}`} data-id="element-72">
            Lisa kommentaar
          </span>
        </button>
        <div className="mx-1.5 my-1 border-t-2 border-gray-300" data-id="element-73"></div>
        <button className="flex items-center gap-2 px-2 py-1.5 hover:bg-gray-100 rounded-md transition-colors" title="Mõõda" data-id="element-74">
          <div className="w-[20px] flex items-center justify-center" data-id="element-75">
            <RulerIcon size={18} className="flex-shrink-0" data-id="element-76" />
          </div>
          <span className={`text-xs whitespace-nowrap overflow-hidden transition-all duration-300 ${isHovered ? 'opacity-100 max-w-[100px]' : 'opacity-0 max-w-0'}`} data-id="element-77">
            Mõõda
          </span>
        </button>
      </div>
    </div>;
};